import { render } from "./ProjVsActuals.vue?vue&type=template&id=70a5d797"
import script from "./ProjVsActuals.vue?vue&type=script&lang=js"
export * from "./ProjVsActuals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/results/ProjVsActuals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a5d797"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a5d797', __exports__)) {
    api.reload('70a5d797', __exports__)
  }
  
  module.hot.accept("./ProjVsActuals.vue?vue&type=template&id=70a5d797", () => {
    api.rerender('70a5d797', render)
  })

}


export default __exports__